/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { useFlags } from 'sarsaparilla';
import PassFeatureFlag from '../components/featureFlags/PassFeatureFlags';
import IAOrderDetailsPage from './IAOrderDetailsPage';
import IAHolidayOrderDetailsPage from './IAHolidayOrderDetailsPage';
import { INTERAGENCY_ANNUAL_PASS_REDESIGN_FLAG } from '../constants';

const propTypes = {};

export default function ReservationPageWrapper(props) {
    const { iaPassesGovShutdown } = useFlags();

    return (
        <PassFeatureFlag
            skeleton
            flag={INTERAGENCY_ANNUAL_PASS_REDESIGN_FLAG}
            fallback={
                <IAOrderDetailsPage
                    {...props}
                    iaPassesGovShutdown={iaPassesGovShutdown}
                />
            }
        >
            <IAHolidayOrderDetailsPage
                {...props}
                iaPassesGovShutdown={iaPassesGovShutdown}
            />
        </PassFeatureFlag>
    );
}

ReservationPageWrapper.propTypes = propTypes;
